import { render } from "./SuccessTemplate.vue?vue&type=template&id=20f588a0"
import script from "./SuccessTemplate.vue?vue&type=script&lang=js"
export * from "./SuccessTemplate.vue?vue&type=script&lang=js"

import "./SuccessTemplate.vue?vue&type=style&index=0&id=20f588a0&lang=css"

import exportComponent from "/home/iman/projects/cornerstone-register/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__